module.exports = __webpack_public_path__ + "static/media/food.7612546d.svg";